import Vue from 'vue';
import {Component, Ref} from 'vue-property-decorator';
import Footer from '@/app/shared/components/footer/Footer.vue';
import IndieInput from '@/app/shared/components/indie-input.vue';
import DatePickerComponent from '../shared/components/date-picker.component.vue'
import CabinClassTravelersDropList from '@/app/cabin-class/cabin-class-travelers.vue';
import MapComponent from '@/app/shared/components/map-component/map.component.vue';
import {CabinClassTravelers} from '../shared/models/cabin-class-travelers.model';
import {debounceTime, pluck, switchMap, map} from 'rxjs/operators';
import {from} from 'rxjs';
import {Inject} from 'inversify-props';
import {SearchService} from '../services/search.service';
import Itinerary from '../shared/models/itinerary.model';
import Trip from '../shared/models/trip.model';
import store from '../../store';
import moment from 'moment';
import {CrmLogService} from '../services/crm-log.service';
import {RouteStopsExtendedInfo} from '../services/route-stops-extended-info'
import Toasted from 'vue-toasted';

import AirlineCreditOverlay from "@/app/shared/components/airline-credit-overlay.component.vue";
import CreditInformationFares from "@/app/shared/components/credit-information-fares.component";
import {CreditService} from "@/app/services/credit.service";
import {INDIE_CONSTANTS} from "@/app/shared/common/constants";
import Helpers from "@/app/shared/common/helpers";
import {AffiliateConfigurationService} from "@/app/services/affiliate-configuration.service";

Vue.use(Toasted);

@Component<Home>({
  components: {
    IndieInput,
    CabinClassTravelersDropList,
    Footer,
    MapComponent,
    DatePickerComponent,
    AirlineCreditOverlay,
    CreditInformationFares
  },
  subscriptions() {
    return ({
      search: this.$fromDOMEvent('.indieInput', 'keyup').pipe(
        debounceTime(300),
        pluck<Event, any>('target'),
        switchMap(elem => from(
          this.getCities(elem).then((res: any) => {
            const dataFor = elem.dataset.for;
            const dataForIndex = elem.dataset.forIndex;
            if (dataFor == this.ROLE_DEPARTURE) {
              this.trips[+parseInt(dataForIndex)].fromCityList = res.data.response;
            } else {
              this.trips[+parseInt(dataForIndex)].toCityList = res.data.response;
            }
            if (res.data.response.length < 1) {
              this.listIsEmpty = true;
              this.trips[+parseInt(dataForIndex)].fromListEmpty = true;
            } else {
              this.listIsEmpty = false;
              this.trips[+parseInt(dataForIndex)].fromListEmpty = false;
            }

            this.cityList = res.data.response;
            this.searchInProcess = false;
            //this.cityListSort(+parseInt(dataForIndex));
          })
        ))
      )
    });
  }
})
export default class Home extends Vue {
  @Inject() public readonly searchService: SearchService;
  @Inject() public readonly creditService: CreditService;
  @Inject() public readonly affiliateConfigurationService: AffiliateConfigurationService;
  @Ref('Pins') private readonly Pins!: any;

  public forceUpdate = true;
  public isEnabledSearch = false;
  public isMapOpened = false;
  public isMapPinging = false;
  public passengerQuantity = 1;
  public listIsEmpty = false;
  public isValidForm = true;
  public allPassengers = 1;
  public mapWasOpened = false;
  public searchInProcess = false;
  public cabinClassTravelers: CabinClassTravelers;
  public cityList: Array<Itinerary> = [];
  public currentIndex: number;
  public tripSearch = store.state.search;
  public trips: Array<Trip> = [];
  public departure = "Departure city";
  public arrival = "Arrival city";
  public searchButtonIsClicked = false;
  public shouldShowAirlineCreditSelectOverlay = false;
  public creditUsageEnabled = false;

  public static readonly toasts: any = {
    flightsNotFound: {
      name: "toast_flights_not_found",
      message: "We're sorry. No flights were found. Please try again with alternate cities or a different cabin class.",
      options: {duration: 10000, theme: "toasted-primary", type: "error", position: "bottom-center"}
    }
  };

  protected static readonly CREDIT_URL_QUERY_PARAM_NAME: string = INDIE_CONSTANTS.CREDIT_URL_QUERY_PARAM_NAME;

  private isCabClassTravOpen = false;
  private flexibleDates: boolean = false;
  private includeNearby: boolean = false;
  private itinerary: Array<Itinerary> = [];
  private round_trip = false;
  private readonly ROLE_DEPARTURE = "departure";
  private readonly ROLE_ARRIVAL = "arrival";

  private tagline = '';

  constructor() {
    super();

    let trip = new Trip();
    trip.date = this.getFirstDate();
    this.trips.push(trip);
    this.cabinClassTravelers = new CabinClassTravelers();
    let localStorageTrips = store.state.trips;
    if (this.tripSearch) {
      if (localStorageTrips.length > 0) {
        this.trips = localStorageTrips
      }

      this.itinerary = this.tripSearch.itinerary || [
        {city: '', date: '', lat: 0, lng: 0, name: ''},
      ];

      this.flexibleDates = this.tripSearch.filters.flexible_dates;
      this.includeNearby = this.tripSearch.filters.include_nearby;

      switch (this.tripSearch.filters.cabin) {
        case 'Y':
          this.cabinClassTravelers.cabinClass = 'Economy';
          break;
        case 'F':
          this.cabinClassTravelers.cabinClass = 'First';
          break;
        case 'C':
          this.cabinClassTravelers.cabinClass = 'Business';
          break;
        default:
          this.cabinClassTravelers.cabinClass = 'Economy';
          break;
      }
      this.cabinClassTravelers.travelers.adults = this.tripSearch.travelers.A;
      this.cabinClassTravelers.travelers.childrens = this.tripSearch.travelers.C;
      this.cabinClassTravelers.travelers.infants = this.tripSearch.travelers.I;
      this.passengerQuantity = this.tripSearch.travelers.A + this.tripSearch.travelers.C;

      this.$nextTick(() => {
        this.redefineItineraryArray();
      })
    }

    this.currentIndex = this.trips.length;
    this.registerToasts();
    this.showNotices();
  }

  public mounted(){
    if(Helpers.isBootstrapLargeOrMore()){
      this.closeOpenMap(true);
    }
      this.handleCreditLink();
  }

  private get affiliateTagline(): string{
    if(store.state.affiliateViewData){
      return store.state.affiliateViewData.tagline;
    }
    return ''
  }

  private registerToasts(){
    this.$toasted.register(Home.toasts.flightsNotFound.name, Home.toasts.flightsNotFound.message, Home.toasts.flightsNotFound.options);
  }
    public get creditData(){
        return this.$store.state.creditData;
    }

  private showNotices(){
    if(this.$toasted && this.$toasted.global){
      let shouldShowFnfNotice = this.$store.state.showFnfNotice;
      if(shouldShowFnfNotice){
        this.$toasted.global[Home.toasts.flightsNotFound.name]();
        this.$store.dispatch("disableFnfNotice");
      }
    }
  }

  public cityListSort(id: number) {
    for (let i = 0; i < this.trips[id].fromCityList.length; i++) {
      if (this.trips[id].fromCityList[i + 1]) {
        let first = this.trips[id].fromCityList[i];
        let second = this.trips[id].fromCityList[i + 1];
        if (first.city < second.city) {
          this.trips[id].fromCityList[i + 1] = first;
          this.trips[id].fromCityList[i] = second;
        }
      }
    }
    for (let i = 0; i < this.trips[id].toCityList.length; i++) {
      if (this.trips[id].toCityList[i + 1]) {
        let first = this.trips[id].toCityList[i];
        let second = this.trips[id].toCityList[i + 1];
        if (first.city < second.city) {
          this.trips[id].toCityList[i + 1] = first;
          this.trips[id].toCityList[i] = second;
        }
      }
    }
  }

  public toCityChange(trip: Trip, currentCity: string, cityItem: Itinerary) {

    if (trip.fromCity === currentCity) {
      this.trips[trip.id].toCity = "";
      this.trips[trip.id].forceUpdate = !this.trips[trip.id].forceUpdate;
    } else {
      this.cityList.filter(async (city: Itinerary) => {
        if (city.code.toLowerCase() === cityItem.code.toLowerCase()) {
          if (this.trips[trip.id].toCity === '' && this.trips[trip.id].fromCity !== '') {
            this.trips[trip.id].toCode = city.code
            this.trips[trip.id].toAirport = city.name;
            this.trips[trip.id].toLat = city.lat;
            this.trips[trip.id].toLng = city.long;
            this.trips[trip.id].toCity = currentCity;
            this.trips[trip.id].toCityObject = city;

            if (!this.trips[1] && this.trips[0].fromCity) {

              await this.createNewTrip();
              this.validate();
            } else {
              if (this.trips[trip.id + 1] && this.trips[trip.id + 1].fromCity === '') {
                this.trips[trip.id + 1].fromCode = city.code
                this.trips[trip.id + 1].fromAirport = city.name;
                this.trips[trip.id + 1].lat = city.lat;
                this.trips[trip.id + 1].lng = city.long;
                this.trips[trip.id + 1].fromCity = currentCity;
                this.trips[trip.id + 1].fromCityObject = city;
                this.validate();
              }
            }

            if (trip.toCity && trip.fromCity && !this.isMapOpened) {
              this.isMapPinging = true;
            }
            return;
          }
          this.trips[trip.id].toCode = city.code;
          this.trips[trip.id].toAirport = city.name;
          this.trips[trip.id].toLat = city.lat;
          this.trips[trip.id].toLng = city.long;
          this.trips[trip.id].toCity = currentCity;
          this.trips[trip.id].toCityObject = city;

          if (!this.trips[1] && this.trips[0].fromCity) {
            this.createNewTrip();
          } else {
            if (this.trips[trip.id + 1] && this.trips[trip.id + 1].fromCity === '') {
              this.trips[trip.id + 1].fromCode = city.code;
              this.trips[trip.id + 1].fromAirport = city.name;
              this.trips[trip.id + 1].lat = city.lat;
              this.trips[trip.id + 1].lng = city.long;
              this.trips[trip.id + 1].fromCity = currentCity;
              this.trips[trip.id + 1].fromCityObject = city;
            }
          }
          this.validate();

        }
      });
    }
    if (trip.toCity && trip.fromCity && !this.isMapOpened) {
      this.isMapPinging = true;
    }

  }

  public fromCityChange(trip: Trip, currentCity: string, cityItem: Itinerary) {

    if (trip.toCity === currentCity) {
      this.trips[trip.id].toCity = "";
      this.trips[trip.id].forceUpdate = !this.trips[trip.id].forceUpdate;
      this.trips[trip.id].toCode = '';
    }

    this.cityList.filter((city: Itinerary) => {
      if (city.code.toLowerCase() === cityItem.code.toLowerCase()) {
        if (this.trips[trip.id].fromCity === '' && this.trips[trip.id].toCity !== '') {
          this.trips[trip.id].fromCode = city.code
          this.trips[trip.id].fromAirport = city.name;
          this.trips[trip.id].lat = city.lat;
          this.trips[trip.id].lng = city.long;
          this.trips[trip.id].fromCity = currentCity;
          this.trips[trip.id].fromCityObject = city;
          if (!this.trips[1] && this.trips[0].toCity) {
            this.createNewTrip();
          }
          if (trip.toCity && trip.fromCity && !this.isMapOpened) {
            this.isMapPinging = true;
          }
          return;
        }
        this.trips[trip.id].fromCode = city.code
        this.trips[trip.id].fromAirport = city.name;
        this.trips[trip.id].lat = city.lat;
        this.trips[trip.id].lng = city.long;
        this.trips[trip.id].fromCity = currentCity;
        this.trips[trip.id].fromCityObject = city;
        if (!this.trips[1] && this.trips[0].toCity) {
          this.createNewTrip();
        }

      }
    });
    if (trip.toCity && trip.fromCity && !this.isMapOpened) {
      this.isMapPinging = true;
    }
  }

  public createNewTrip() {
    if (this.trips.length >= 20) {
      return;
    }

    const trip = new Trip();
    trip.date = this.getNextDate();
    this.trips.push(trip);

    if (this.trips[this.currentIndex - 1].toCity === this.trips[0].fromCity) {
      this.trips[this.currentIndex - 1].toLng = 0;
      this.trips[this.currentIndex - 1].toLat = 0;
      this.trips[this.currentIndex - 1].toCity = '';
      this.trips[this.currentIndex - 1].toCode = '';
      this.trips[this.currentIndex - 1].toAirport = '';
      this.trips[this.currentIndex - 1].toCityObject = null;
    }

    if (this.trips[this.currentIndex - 1].toCity !== this.trips[0].fromCity) {
      this.trips[this.currentIndex].lng = this.trips[this.currentIndex - 1].toLng;
      this.trips[this.currentIndex].lat = this.trips[this.currentIndex - 1].toLat;
      this.trips[this.currentIndex].fromCity = this.trips[this.currentIndex - 1].toCity;
      this.trips[this.currentIndex].fromCode = this.trips[this.currentIndex - 1].toCode
      this.trips[this.currentIndex].fromAirport = this.trips[this.currentIndex - 1].toAirport;
      this.trips[this.currentIndex].fromCityObject = this.trips[this.currentIndex - 1].toCityObject;
    }

    if (this.trips.length === 2) {
      this.trips[1].fromCity = this.trips[0].toCity;
      this.trips[1].lat = this.trips[0].toLat;
      this.trips[1].lng = this.trips[0].toLng;
      this.trips[1].fromCode = this.trips[0].toCode;
      this.trips[1].fromAirport = this.trips[0].toAirport;
      this.trips[1].fromCityObject = this.trips[0].toCityObject;
    }

    this.trips[this.currentIndex].toCity = this.trips[0].fromCity;
    this.trips[this.currentIndex].toLat = this.trips[0].lat;
    this.trips[this.currentIndex].toLng = this.trips[0].lng;
    this.trips[this.currentIndex].toCode = this.trips[0].fromCode;
    this.trips[this.currentIndex].toAirport = this.trips[0].fromAirport;
    this.trips[this.currentIndex].toCityObject = this.trips[0].fromCityObject;

    this.currentIndex = this.trips.length;
    this.forceUpdate = !this.forceUpdate;
    this.redefineItineraryArray();
    if (this.isMapOpened) {
      this.Pins.redefinePinsArray(this.trips);
    }
    this.searchingValuesFixation();
    this.forceUpdate = !this.forceUpdate;
  }

  public removeTrip(removableTrip: Trip) {
    this.forceUpdate = !this.forceUpdate;
    for (let i = 0; i < this.trips.length; i++) {
      if (removableTrip === this.trips[i]) {
        this.trips.splice(i, 1);

        if (!this.trips[this.currentIndex - 2].toCity && this.trips.length > 2) {
          this.trips[this.currentIndex - 2].toCity = this.trips[0].fromCity;
          this.trips[this.currentIndex - 2].toLat = this.trips[0].lat;
          this.trips[this.currentIndex - 2].toLng = this.trips[0].lng;
          this.trips[this.currentIndex - 2].toCode = this.trips[0].fromCode
          this.trips[this.currentIndex - 2].toAirport = this.trips[0].fromAirport;
          this.trips[this.currentIndex - 2].toCityObject = this.trips[0].fromCityObject;
        }

        this.redefineItineraryArray();
        this.searchingValuesFixation();
        if (this.isMapOpened) {
          this.Pins.redefinePinsArray(this.trips);
        }
        this.currentIndex--;
      }
    }

    if (this.trips.length > 1 && !this.trips[1].fromCity) {
      this.trips[1].toCity = this.trips[0].toCity;
      this.trips[1].toLat = this.trips[0].toLat;
      this.trips[1].toLng = this.trips[0].toLng;
      this.trips[1].toCode = this.trips[0].toCode
      this.trips[1].toAirport = this.trips[0].toAirport;
      this.trips[1].toCityObject = this.trips[0].toCityObject;
    }
    this.validate();
    this.searchingValuesFixation();
    this.forceUpdate = !this.forceUpdate;
  }

  public closeOpenCabClassTrav() {
    this.isCabClassTravOpen = !this.isCabClassTravOpen;
  }

  public allPassengersCounter() {
    this.allPassengers = this.cabinClassTravelers.travelers.adults + this.cabinClassTravelers.travelers.childrens + this.cabinClassTravelers.travelers.infants;
  }

  passengerIncrement(value: number) {
    switch (value) {
      case 1:
        if (this.passengerQuantity < 9) {
          this.passengerQuantity++;
          this.cabinClassTravelers.travelers.adults++;
        }
        break;
      case 2:
        if (this.passengerQuantity < 9) {
          this.passengerQuantity++;
          this.cabinClassTravelers.travelers.childrens++;
        }
        break;
      case 3:
        if (this.cabinClassTravelers.travelers.infants < this.cabinClassTravelers.travelers.adults) {
          this.cabinClassTravelers.travelers.infants++;
        }
        break;

      default:
        break;
    }
    this.allPassengersCounter();
  }

  passengerDecrement(value: number) {
    switch (value) {
      case 1:
        if (this.cabinClassTravelers.travelers.adults > 1) {
          this.cabinClassTravelers.travelers.adults--;
          this.passengerQuantity--;
          if (this.cabinClassTravelers.travelers.infants > this.cabinClassTravelers.travelers.adults) {
            this.cabinClassTravelers.travelers.infants = 0;
          }
        }
        break;
      case 2:
        if (this.cabinClassTravelers.travelers.childrens > 0) {
          this.cabinClassTravelers.travelers.childrens--;
          this.passengerQuantity--;
          if (this.cabinClassTravelers.travelers.infants > this.cabinClassTravelers.travelers.adults) {
            this.cabinClassTravelers.travelers.infants = 0;
          }
        }
        break;
      case 3:
        if (this.cabinClassTravelers.travelers.infants > 0) {
          this.cabinClassTravelers.travelers.infants--;
        }
        break;

      default:
        break;
    }
    this.allPassengersCounter();
  }

  public selectedClass(selectedClass: string) {
    this.cabinClassTravelers.cabinClass = selectedClass;
  }

  public selectDate(trip: Trip, selectedDate: string) {

    if (!selectedDate) {
      selectedDate = '';
      this.trips[trip.id].date = selectedDate;
      this.searchingValuesFixation();
    }
    this.trips[trip.id].date = selectedDate;
    this.searchingValuesFixation();
    this.forceUpdate = !this.forceUpdate;
  }

  private getFirstDate() {
    const defaultDaysOffset = 42;
    let date = new Date(new Date().getTime() + defaultDaysOffset * 24 * 60 * 60 * 1000);
    const dayOfWeek = date.getDay();

    if (dayOfWeek > 3) {
      date = new Date(new Date().getTime() + (defaultDaysOffset + 7 - dayOfWeek + 3) * 24 * 60 * 60 * 1000); //42 days plus one week and go to next wednesday
    } else {
      date = new Date(new Date().getTime() + (defaultDaysOffset + 3 - dayOfWeek) * 24 * 60 * 60 * 1000); //42 days plus go to next wednesday
    }

    return moment(date, 'DD-MMM-YYYY').format('DD-MMM-YYYY');//default is 42 days after today
  }

  getNextDate() {
    if (typeof this.trips[this.currentIndex - 1] === 'undefined'){
      return this.getFirstDate();
    }
    return moment(this.trips[this.currentIndex - 1].date, 'DD-MMM-YYYY')
      .set('d', moment(this.trips[this.currentIndex - 1].date, 'DD-MMM-YYYY').get('d') + 7)
      .format('DD-MMM-YYYY');
  }

  public cityValidate(currCity: string) {
    if (currCity) {
      this.cityList.filter(async (city) => {
        if (city.city.toLowerCase().includes(currCity.toLowerCase())) {
          if (city.city.toLowerCase() === currCity.toLowerCase()) {
            await this.searchingValuesFixation();
            await this.redefineItineraryArray();
          }
          return;
        }
      });
    }
  }

  public async searchingValuesFixation() {
    await this.redefineItineraryArray();

    for (let i = 0; i < this.trips.length; i++) {
      this.trips[i].id = i;
    }

    let cabinClass = 'Y';

    switch (this.cabinClassTravelers.cabinClass) {
      case 'Economy':
        cabinClass = 'Y';
        break;
      case 'First':
        cabinClass = 'F';
        break;
      case 'Business':
        cabinClass = 'C';
        break;
      default:
        break;
    }

    const searchData = {
      filters:
        {
          airport_change: false,
          alliance: ['0'],
          cabin: cabinClass,
          cluster: true,
          flexible_dates: this.flexibleDates,
          hub: true,
          include_nearby: this.includeNearby,
          round_trip: this.round_trip
        },
      itinerary: this.itinerary,
      travelers:
        {
          A: this.cabinClassTravelers.travelers.adults,
          C: this.cabinClassTravelers.travelers.childrens,
          I: this.cabinClassTravelers.travelers.infants,
        },
      currency: 'USD'
    };

    store.commit('saveSearch', searchData);
    store.commit('saveTrips', this.trips);
  }

  public getCities(elem: any) {
      this.cityList = [];
      this.searchInProcess = true;
      return this.searchService.getCityList(elem.value);
  }

  private validate() {
    for (let i = 0; i < this.trips.length; i++) {
      if (!this.trips[i].fromCity || !this.trips[i].toCity || !this.trips[i].date) {
        this.isValidForm = false;
        return;
      }
    }
    this.isValidForm = true;
  }

  public async goToSearchResult() {
    await this.searchingValuesFixation();
    await this.validate();
    if (!this.isValidForm) return;
    store.commit('startSearch');
    this.$router.push('search-result');
  }

  public closeOpenMap(forceOpen: boolean = false) {
    this.isMapPinging = false;
    if (!this.isMapOpened) {
      // Map is closed. Open it
      const nav = this.$el.querySelector('nav');
      if (nav) { nav.classList.remove('show'); }
      this.isMapOpened = true;
      return;
    } else if (this.isMapOpened && !forceOpen) {
      // Map is open. Close it
      const nav = this.$el.querySelector('nav');
      if (nav) { nav.classList.add('show'); }
      this.isMapOpened = false;
      return;
    }
  }

  private redefineItineraryArray() {
    this.itinerary = [];

    this.trips.filter((trip: Trip) => {
      let firstItinerary = trip.fromCityObject;
      if (firstItinerary) {
        firstItinerary.departure_date = moment(trip.date, 'DD-MMM-YYYY').format('DD-MMM-YYYY');
        firstItinerary.byland = '0';

      }

      let secondItinerary = trip.toCityObject;
      if (secondItinerary) {
        secondItinerary.departure_date = '';
        secondItinerary.byland = '0';
      }

      if (this.itinerary.length > 1) {
        if (this.itinerary[this.itinerary.length - 1].city.toLowerCase() !== trip.fromCity.toLowerCase() && this.trips[this.currentIndex - 2].toCity !== undefined) {
          this.itinerary[this.itinerary.length - 1].byland = '1';

          if (firstItinerary)
            if (firstItinerary.id) {
              this.itinerary.push(firstItinerary);
            }

        } else {
          this.itinerary[this.itinerary.length - 2].byland = '0';
          this.itinerary[this.itinerary.length - 1].departure_date = trip.date;
        }
        if (secondItinerary)
          if (secondItinerary.city) {
            this.itinerary.push(secondItinerary);
            return;
          }
        return;
      }

      if (firstItinerary) {
        this.itinerary.push(firstItinerary);
      }


      if (secondItinerary)
        if (secondItinerary.city) {
          this.itinerary.push(secondItinerary);
        }
    });

    if (this.itinerary.length > 0) {
      this.itinerary[0].departure_date = this.trips[0].date;
      this.itinerary[this.itinerary.length - 1].departure_date = '';
    }

  }

  public created() {
    new CrmLogService().add(CrmLogService.LOG_REACHED_SEARCH);

    const routeString = this.isFixedRoutePage();
    if ( routeString ){
      this.loadItineraryFromUrl(routeString);
    }

  }

  private isFixedRoutePage() {
    const match = location.pathname.match(/^\/?[a-z]{3}(?:-[a-z]{3})+$/i);
    if (match) {
      return match[0].replace(/^\//, '');
    }
    return false;
  }

  private loadItineraryFromUrl(routeString: string) {

    this.trips = [];

    new RouteStopsExtendedInfo().getInfo(routeString)
      .then(stopsInfo => {

        for (let i = 0; i < stopsInfo.length - 1; i++) {

          let trip = new Trip();

          trip.fromCode = stopsInfo[i].code;
          trip.fromAirport = stopsInfo[i].name;
          trip.fromCity = stopsInfo[i].city;
          trip.lng = stopsInfo[i].long;
          trip.lat = stopsInfo[i].lat;
          trip.fromCityObject = stopsInfo[i];
          if( trip.fromCityObject ){
            trip.fromCityObject.currency = 'USD';
          }

          trip.toCode = stopsInfo[i + 1].code;
          trip.toAirport = stopsInfo[i + 1].name;
          trip.toCity = stopsInfo[i + 1].city;
          trip.toLng = stopsInfo[i + 1].long;
          trip.toLat = stopsInfo[i + 1].lat;
          trip.toCityObject = stopsInfo[i + 1];

          trip.date = this.getNextDate();

          this.trips.push(trip);

          this.currentIndex = this.trips.length;
        }

        this.forceUpdate = !this.forceUpdate;
        this.redefineItineraryArray();
        if (this.isMapOpened) {
          this.Pins.redefinePinsArray(this.trips);
        }
        this.searchingValuesFixation();
        this.forceUpdate = !this.forceUpdate;
      });
  }

  protected handleCreditLink() {
    let creditLinkStr = null;
    if (this.$route.query.hasOwnProperty(Home.CREDIT_URL_QUERY_PARAM_NAME)) {
      creditLinkStr = this.$route.query[Home.CREDIT_URL_QUERY_PARAM_NAME].toString();
    }

    if (creditLinkStr === null || creditLinkStr.length < 1) {
      creditLinkStr = this.$cookies.get(INDIE_CONSTANTS.CREDIT_STRING_COOKIE_KEY);
    }
    //const creditUrlParam: string = this.$route.query[App.CREDIT_URL_QUERY_PARAM_NAME].toString();
    if (creditLinkStr && creditLinkStr.length > 0) {
      this.$store.dispatch("storeCreditUrlParam", {creditLinkStr});
      this.$cookies.set(INDIE_CONSTANTS.CREDIT_STRING_COOKIE_KEY, creditLinkStr);
      this.creditService.readUrlParam(creditLinkStr)
        .then((res: any) => {
          const creditInfo = res.data.response;
          this.$store.dispatch("storeCreditData", creditInfo);
          this.handleAvailableCreditData();
        })
        .catch((err: any) => {
          console.log(err);
        })
    }
  }

  protected handleAvailableCreditData() {
    const rcr = this.$store.state.creditData;
    if (rcr && rcr.hasOwnProperty("credit_data")) {
      const hasCredit = rcr.has_airline_credit || rcr.credit_data.airtreks_credit > 0;
      if(rcr.hasOwnProperty("can_use_credit") && hasCredit){
        this.creditUsageEnabled = !!rcr.can_use_credit;
        this.shouldShowAirlineCreditSelectOverlay = true;
        return;
      }
      if (rcr && hasCredit) {
        if (rcr.credit_data.hasOwnProperty("passengers_credit")) {
          this.shouldShowAirlineCreditSelectOverlay = true;
        }
      }
    }
  }

  public onCreditSelectionAccepted(acceptedValues: any[], fares: any[]){
    this.$bvModal.show('credit-information-fares');
  }

}
